export default __webpack_public_path__ + "images/0x503234f203fc7eb888eec8513210612a43cf6115.png";